import { currentLocale } from "./currentLocale";
import { locales } from "./date-fns-locales";

/**
 * Return the short, capitalized day name in the current locale (For example: 'Mo' in en-us, 'Lu' in es-es)
 * @param day Day of the week, 0 = Sunday … 6 = Saturday
 */
export const shortDayName = (day: number) => {
	const name = locales[currentLocale()].localize.day(day, { width: "short" });
	return name.charAt(0).toLocaleUpperCase() + name.slice(1);
};
